import { render, staticRenderFns } from "./ChecadorWebcam.vue?vue&type=template&id=4cecbb6b&scoped=true"
import script from "./ChecadorWebcam.vue?vue&type=script&lang=js"
export * from "./ChecadorWebcam.vue?vue&type=script&lang=js"
import style0 from "./ChecadorWebcam.vue?vue&type=style&index=0&id=4cecbb6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cecbb6b",
  null
  
)

export default component.exports